import React from 'react';
import { Linking, Platform, StyleSheet, View } from 'react-native';
import { WebView } from 'react-native-webview';
import { MicrositeViewHTML  } from './view';

const MicrositeHTML = () => {
    const [baseURL, setBaseURL] = React.useState('')

    Linking.getInitialURL().then(url => {
        if (url) {
          const baseUrl = new URL(url).origin;
          if (baseUrl)
            setBaseURL(`${baseUrl}/`)
        }
      });

    if (Platform.OS === 'web') {
      // For web, render iframe
      return baseURL ? (
        <iframe
          srcDoc={MicrositeViewHTML(baseURL)}
        //   src={'https://signsecure-ws.unawa.io/'}
          style={{ flex: 1, width: '100%', height: '100%', border: 'none' }}
          title="Microsite"
        />
      ) : (
        <></>
      );
    } else {
      // For iOS and Android, use WebView
      return baseURL ? (
        <WebView
          originWhitelist={['*']}
          source={{ html: MicrositeViewHTML(baseURL) }}
          style={styles.container}
        />
      ): (
        <></>
      );
    }
  };
  
  const styles = StyleSheet.create({
    container: { flex: 1 },
  });
  
  export default MicrositeHTML;